<script setup lang="ts">
    const props = defineProps({
        title: {
            type: String,
            required: false,
        },
        show: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: String,
            default: null,
        },
    })
</script>

<template>
    <v-container class="full-loader" :show="show">
        <span
            class="d-flex justify-center align-center p-3"
            style="flex-direction: column; height: 90dvh"
        >
            <!--            <AppLogo />-->
            <h1 v-if="title">{{ title }}</h1>
            <v-progress-circular v-if="!errors" indeterminate color="primary" />
            <v-alert v-else>{{ errors }}</v-alert>
        </span>
    </v-container>
</template>
